module.exports = __webpack_public_path__ + "img/矢量智能对象@3x(3).262c3c31.png";